export type SegmentOption<T extends string> = { value: T; label: string; title?: string; disabled?: boolean };

/** Сегмент: плашка подписи слева, варианты кнопками справа (как в supply). Пустая подпись — без плашки
 * (вкладки раздела, №376: «слово „вкладка“ лишнее»); тогда метка разметки — `annot`. */
export function Segmented<T extends string>({
  label: caption,
  options,
  value,
  onPick,
  annot,
}: {
  label: string;
  options: SegmentOption<T>[];
  value: T;
  onPick: (value: T) => void;
  annot?: string;
}) {
  return (
    <div
      className="flex h-8 max-w-full overflow-x-auto rounded-[var(--radius-ui)] border border-border bg-bg text-[12.5px]"
      data-annot={annot ?? caption}
    >
      {caption ? (
        <span className="flex flex-none items-center whitespace-nowrap border-r border-border bg-bg-subtle px-2 text-[11.5px] text-fg-faint">
          {caption}
        </span>
      ) : null}
      {options.map((o, i) => {
        const on = o.value === value;
        return (
          <button
            key={o.value}
            type="button"
            aria-pressed={on}
            title={o.title}
            disabled={o.disabled}
            onClick={() => onPick(o.value)}
            className={
              "flex-none whitespace-nowrap px-2.5 " +
              (i > 0 ? "border-l border-border " : "") +
              (o.disabled
                ? "cursor-not-allowed text-fg-faint line-through"
                : on
                  ? "bg-accent/10 font-medium text-accent-text"
                  : "text-fg-muted hover:bg-bg-hover hover:text-fg")
            }
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
}
